import React from 'react';
import GridContainer from '../../../../@jumbo/components/GridContainer';
import PageContainer from '../../../../@jumbo/components/PageComponents/layouts/PageContainer';
import IntlMessages from '../../../../@jumbo/utils/IntlMessages';

import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

import AddUser from '@jumbo/Dashboards/Users/AddUser';

const breadcrumbs = [
  { label: <IntlMessages id={'sidebar.main'} />, link: '/' },
  { label: <IntlMessages id={'pages.usersPage'} />, link: '/users' },
  { label: <IntlMessages id={'pages.createUserPage'} />, isActive: true },
];

const CreateUser = () => {
  return (
    <PageContainer heading={<IntlMessages id="pages.createUserPage" />} breadcrumbs={breadcrumbs}>
      <GridContainer>
        <Grid item xs={12}>
          <div style={{ marginBottom: 10 }}>
            <IntlMessages id="pages.createUserPage.description" />
          </div>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <AddUser />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default CreateUser;
